import { render, staticRenderFns } from "./SectionComponent.vue?vue&type=template&id=5dd85a19&scoped=true&"
import script from "./SectionComponent.vue?vue&type=script&lang=ts&"
export * from "./SectionComponent.vue?vue&type=script&lang=ts&"
import style0 from "./SectionComponent.vue?vue&type=style&index=0&id=5dd85a19&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd85a19",
  null
  
)

export default component.exports